export default (i, last, flag) => flag === 'last' ?
    i === last :
    flag === 'first' ?
        i === 0 :
        typeof flag === 'boolean' ?
            flag :
            !!flag && flag[i];
